import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs, P } from "../../../AbstractElements";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { DarkFooter, PageLayout, SampleCard, SampleCardText } from "../../../Constant";

const FooterDarkContainer = () => {
  return (
    <>
      <Breadcrumbs pageTitle={DarkFooter} parent={PageLayout} title={DarkFooter} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CommonCardHeader title={SampleCard} text={SampleCardText} />
              <CardBody>
                <P>"Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum."</P>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default FooterDarkContainer;
